import { INTEGRATION_CATEGORIES as CATEGORIES } from '~/services/integrations';
import { INTEGRATIONS } from '~/services/integrations';

export const TOTAL_UNIFIED_APIS = Object.keys(CATEGORIES).length;
export const TOTAL_INTEGRATIONS = INTEGRATIONS.length;
